import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./caseStudies.scss";

const CaseStudies = () => {
  const allCards = [
    {
      id: 1,
      title: "Baileigh Industrial",
      category: "B2B PRODUCT",
      description: "US Manufacturer Enters The Australian Market & Enjoys A 20% Online Conversion Rate",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/baileigh-industrial.jpg",
    },
    {
      id: 2,
      title: "Opinion World",
      category: "B2B SERVICES",
      description: "Online Survey Group gain an additional 30,000+ site visitors in just 6 months",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/opinion-world.jpg",
    },
    {
      id: 3,
      title: "UnBirthday Bakery",
      category: "B2C PRODUCT",
      description: "Bespoke Cake Shop Finds Digital Sweet Spot!",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/unbirthday-bakery.jpg",
    },
    {
      id: 4,
      title: "Melbourne Institute of Technology (MIT)",
      category: "B2C SERVICES",
      description: "Education Provider Gains 76% More Conversions Within 3 Months",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/mit.jpg",
    },
    {
      id: 5,
      title: "ACO Australia",
      category: "B2B PRODUCT",
      description: "Drainage Manufacturer’s Google Exposure grows within 5 Months",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/aco-australia.jpg",
    },
    {
      id: 6,
      title: "JDN Monocrane",
      category: "B2B PRODUCT",
      description: "Manufacturer Boosts Enquiries By 46% Within 1 Year",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/jdn.jpg",
    },
    {
      id: 7,
      title: "Fifth Quadrant",
      category: "B2B SERVICES",
      description: "Customer Research and Consulting group attracts larger clients",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/fifth-quadrant.jpg",
    },
    {
      id: 8,
      title: "AVO Clean",
      category: "B2B SERVICES",
      description: "Window and façade maintenance business",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/avoclean.jpg",
    },
    {
      id: 9,
      title: "Mountain Bread",
      category: "B2C PRODUCT",
      description: "Food Retailer increases wins increases 20% sales on Supermarket Shelves",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/mountain-bread.jpg",
    },
    {
      id: 10,
      title: "Great Ocean Properties",
      category: "B2C SERVICES",
      description: "Luxury Real Estate Agency Increases Sales by 48%",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/great-ocean-properties.jpg",
    },
    {
      id: 11,
      title: "English Key",
      category: "B2C SERVICES",
      description: "Language Tuition Centre Grows Business by 58%",
      image: "https://arrowdigital.com.au/wp-content/uploads/2023/02/english-key.jpg",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("ALL");
  const cardsPerPage = 6;

  useEffect(() => {
    setCurrentPage(1);
  }, [filter]);

  const filteredCards = filter === "ALL" ? allCards : allCards.filter((card) => card.category === filter);

  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  const currentCards = filteredCards.slice(indexOfFirstCard, indexOfLastCard);
  const totalPages = Math.ceil(filteredCards.length / cardsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <Helmet>
        <title>Case Studies | Arrow Digital Marketing</title>
        <meta
          name="description"
          content="Explore real client success stories with Arrow Digital. From B2B to B2C, see how our digital marketing strategies deliver results."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://arrowdigitalmarketing.com/case-studies" />

        {/* Open Graph */}
        <meta property="og:title" content="Case Studies | Arrow Digital Marketing" />
        <meta
          property="og:description"
          content="Real success stories powered by Arrow Digital's expert strategies. Discover how we help businesses grow."
        />
        <meta property="og:url" content="https://arrowdigitalmarketing.com/case-studies" />
        <meta property="og:image" content="https://arrowdigitalmarketing.com/og-case-studies.jpg" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Case Studies | Arrow Digital" />
        <meta
          name="twitter:description"
          content="Read inspiring case studies from Arrow Digital clients. B2B & B2C businesses that scaled using our digital marketing expertise."
        />
        <meta name="twitter:image" content="https://arrowdigitalmarketing.com/og-case-studies.jpg" />
      </Helmet>

      <div className="app">
        {/* Top Image */}
        <div className="top-image-container">
          <img src="casestudies.png" alt="Top Banner" className="top-image" />
        </div>

        {/* Filter Buttons */}
        <div className="filter-buttons">
          {["ALL", "B2B PRODUCT", "B2B SERVICES", "B2C PRODUCT", "B2C SERVICES"].map((category) => (
            <button
              key={category}
              onClick={() => setFilter(category)}
              className={filter === category ? "active" : ""}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Cards */}
        <div className="card-container">
          {currentCards.length > 0 ? (
            currentCards.map((card) => (
              <div className="card" key={card.id}>
                <Link to={`/case-study/${card.id}`}>
                  <img src={card.image} alt={card.title} className="card-image" />
                </Link>
                <div className="card-content">
                  <h3>
                    <Link to={`/case-study/${card.id}`}>{card.title}</Link>
                  </h3>
                  <p>{card.description}</p>
                </div>
              </div>
            ))
          ) : (
            <p>No case studies available for this category.</p>
          )}
        </div>

        {/* Pagination */}
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={currentPage === index + 1 ? "active" : ""}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default CaseStudies;
